(ns practitest.frontend.components2.dashboard.schema
  (:require [practitest.frontend.components2.dashboard.chart :as-alias chart]
            [malli.core :as m]
            [malli.util :as mu]
            [malli.registry :as mr]))

(defn- sorted-pred [{:keys [by order]}]
  (let [comp (if (= order :desc) >= <=)]
    #(let [values (seq (map by %))]
       (if values
         (apply comp values)
         true))))

;; Malli schema that validates a collection is sorted.
;; Options:
;;   :by    — keyword or fn to extract the sort key (optional, defaults to identity)
;;   :order — :asc or :desc
;; Usage:
;;   [:and
;;    [:vector [:map [:value number?]]]
;;    [:sorted {:by :value :order :desc}]]
(def Sorted
  (m/-simple-schema
   (fn [{:keys [by order] :as opts} _]
     (let [error-msg (str "must be sorted by " (name by) " " (name order))]
       {:type              :sorted
        :pred              (sorted-pred opts)
        :type-properties   {:error/message error-msg}
        :properties-schema [:map
                            [:by :keyword]
                            [:order [:enum :asc :desc]]]}))))

(mr/set-default-registry!
 (merge (m/default-schemas)
        (mu/schemas)
        {:sorted Sorted}))

(def ColorMap
  [:map-of [:string {:min 1}] [:string {:min 1}]])

(def PieData
  [:vector
   [:tuple :string number?]])

(def PlannedVsExecutedData
    [:map
     [:executed
      [:vector
       [:map
        [:date :string]
        [:instance-runned :int]]]]
     [:planned
      [:vector
       [:map
        [:date :string]
        [:instance-runned :int]]]]])

(def SeriesCategories
  [:map
   [:series [:vector
             [:map
              [:name :string]
              [:data [:vector :int]]]]]
   [:categories [:vector :string]]])

(def Route
  [:map
   [:uri :string]
   [:ext [:map-of :keyword :string]]
   [:params [:vector [:tuple :string :string]]]])

(def ChartItem
  [:map
   [:chart/id :int]
   [:chart/title :string]
   [:chart/sub-title [:maybe :string]]
   [:chart/item-route [:maybe Route]]
   [:chart/user-colors [:maybe ColorMap]]
   [:chart/percentage-mode :boolean]
   [:chart/remove-empty-values :boolean]
   [:chart/cell-width {:optional true} [:maybe [:enum :regular :double]]]
   [:chart/legend-location {:optional true} [:maybe [:enum :Bottom :No-Legend]]]])

(def PieDataItem
  [:map
   [:value number?]])

(def PieChart
  [:merge
   ChartItem
   [:map
    [:chart/type [:= ::chart/pie]]
    [:chart/data PieData]]])

(def PieChartTransformed
  [:merge
   PieChart
   [:map
    [:chart/data
     [:and
      [:vector PieDataItem]
      [:sorted {:by :value :order :desc}]]]]])

(def BarChart
  [:merge
   ChartItem
   [:map
    [:chart/type [:= ::chart/bar]]
    [:chart/data SeriesCategories]]])

(def PlannedVsExecutedChart
  [:merge
   ChartItem
   [:map
    [:chart/type [:= ::chart/line]]
    [:chart/data PlannedVsExecutedData]]])

(def StackedBarChart
  [:merge
   ChartItem
   [:map
    [:chart/type [:= ::chart/stacked-bar]]
    [:chart/data SeriesCategories]]])
